import { CollectionModel } from '@shared/models/restapi/Collection.Model';
import { AdvancedSearchResultModel } from '@em/models/restapi/AdvancedSearchResult.Model';

export class AdvancedSearchResultCollectionModel extends CollectionModel<AdvancedSearchResultModel> {
    public constructor() {
        super(AdvancedSearchResultModel);
    }
}
